// extracted by mini-css-extract-plugin
export default {"container":"TableSummaryHeader_container__LIahP"};